const load = () => {
  return {
    page_title: "Tariffs"
  };
};
export {
  load
};
//# sourceMappingURL=_page.ts.js.map
